var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuota(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1329",
    "data-name": "Group 1329",
    transform: "translate(-5829 -3398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1328",
    "data-name": "Group 1328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1327",
    "data-name": "Group 1327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M5840,3400.738a8.262,8.262,0,1,0,8.262,8.262A8.174,8.174,0,0,0,5840,3400.738Zm.645,1.319a6.877,6.877,0,0,1,6.3,6.3h-6.3Zm-.645,13.914a6.972,6.972,0,0,1-.645-13.914v7.21l5.118,5.119A6.975,6.975,0,0,1,5840,3415.971Zm5.386-2.5-3.828-3.828h5.385A6.938,6.938,0,0,1,5845.386,3413.473Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_567",
    "data-name": "Rectangle 567",
    width: 22,
    height: 22,
    transform: "translate(5829 3398)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuota);
export default __webpack_public_path__ + "static/media/icon-quota.fe053abc49d50e8b36cbd3b59be32b60.svg";
export { ForwardRef as ReactComponent };